import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Edit from "@material-ui/icons/Edit";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { dateformat } from "../../../../../utils/dateFormat";
import { useDetailsInfoStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TotemToken from "../../../components/token";
import { Link, useLocation } from "react-router-dom";
import { usePermission } from "../../../../../hooks/usePermission";
import { Totem } from "../../../../../@types/totem";
import TotemResetPassword from "./components/reset-password";
import TotemLogoPreview from "./components/logo-preview";
import TotemActiveToggle from "../../../components/active-toggle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

type DetailsInfoProps = {
    totem: Totem;
};

export default function DetailsInfo({ totem }: DetailsInfoProps) {
    const { pathname } = useLocation();
    const { isAboveCoordenator } = usePermission();
    const { classes } = useDetailsInfoStyles();

    return (
        <Paper elevation={3}>
            <Box className={classes.head}>
                <Box className={classes.container}>
                    <Box className={classes.header}>
                        <Typography className={classes.title}>
                            {totem?.descricao}
                        </Typography>
                    </Box>
                    <Box className={classes.infosContainer}>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Adicionado: {dateformat(totem?.created_at, true)}
                            </Typography>
                        </Box>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Atualizado em: {dateformat(totem?.updated_at, true)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box className={classes.headerButtonGroup}>
                    <TotemActiveToggle
                        totem={totem}
                        buttonTrigger={
                            <FormControlLabel
                                labelPlacement="start"
                                label={totem?.ativo ? "Totem Ativo" : "Totem Inativo"}
                                control={<Switch onChange={() => { }} checked={totem?.ativo || false} />}
                            />
                        }
                    />
                    {isAboveCoordenator && (
                        <Button
                            component={Link}
                            to={`${pathname}/editar`}
                            startIcon={<Edit fontSize="small" />}
                            className={classes.editButton}
                        >
                            Editar
                        </Button>
                    )}
                </Box>
            </Box>
            <Divider />
            <Box className={classes.content}>
                <Typography className={classes.subtitle}>
                    Informações do totem
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Token
                        </Typography>
                        <TotemToken totem={totem} />
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Descrição
                        </Typography>
                        <Typography className={classes.totemInfoText}>
                            {totem?.descricao || "Nenhuma descrição cadastrada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Órgão
                        </Typography>
                        <Typography className={classes.totemInfoText}>
                            {totem?.orgao?.nome || "Nenhum órgão vinculado."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Local de Atendimento
                        </Typography>
                        <Typography className={classes.totemInfoText}>
                            {totem?.local_atendimento?.nome || "Nenhum local vinculado."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Cor da Fonte
                        </Typography>
                        <Typography
                            className={classes.totemInfoText}
                            style={{ display: "flex", alignItems: "center", gap: "10px" }}
                        >
                            {totem?.cor_fonte && (
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: totem?.cor_fonte,
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                            {totem?.cor_fonte || "Nenhuma cor definida."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Cor de Fundo
                        </Typography>
                        <Typography
                            className={classes.totemInfoText}
                            style={{ display: "flex", alignItems: "center", gap: "10px" }}
                        >
                            {totem?.cor_fundo && (
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: totem?.cor_fundo,
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                            {totem?.cor_fundo || "Nenhuma cor definida."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Senha de Reset
                        </Typography>
                        <TotemResetPassword totem={totem} />
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Logo do Totem
                        </Typography>
                        <TotemLogoPreview totem={totem} />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
